import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { configuration } from '../../configuration';
import { SharedService } from './shared.service';
import { environment } from 'src/environments/environment';
 
@Injectable({
  providedIn: 'root'
})
export class ApiServiceService {


  public headers:any = {};
  public methodType = configuration.REQUEST.POST;
  public URL = '';
  public isBlob = false;
  public isUploadImage = false;
  public isUploadfFavicon = false;
  public API_URL = environment.API_URL;

  constructor(public http: HttpClient, public shared: SharedService) { }

  public createAuthorizationHeaderFormData() {
    let headers:any;
    headers = {
      'Content-Type': 'application/json',
    };

    const token = this.shared.getTokenValue();
    if (token && token !== '') {
      headers.Authorization = 'Bearer ' + token;      
    }

    return headers;
  }

  public handleErrorObservable(error: Response | any) {
    if (error.status && error.status == 401) {
      status = error.status;
      return null;
    } else {
      var response = error.message || error;
      let responseJson = { is_error: true, message: response };
      return responseJson;
    }
  }

  public getAPIURL(url:string) {
    return this.API_URL + url;
  }

  async makeRequest(url:string, data:any) {
    this.headers = {};
      this.headers = this.createAuthorizationHeaderFormData();
      this.URL = this.getAPIURL(url);


    if (this.isUploadImage) {
      delete this.headers["Content-Type"];
    }
    this.isUploadImage = false;
    switch (this.methodType) {
      case configuration.REQUEST.POST:
        return await this.post(data);
      case configuration.REQUEST.GET:
        return await this.get();
      case configuration.REQUEST.DELETE:
        return await this.delete();
      case configuration.REQUEST.PUT:
        return await this.put(data);
      case configuration.REQUEST.PATCH:
        return await this.patch(data);        
    }
  }

  public async post(data:any): Promise<any> {
    let requestParam:any;
    requestParam = {};
    requestParam.headers = this.headers;
    const blob =  this.isBlob ? true : false;
    if (this.isBlob) {
      requestParam.responseType = 'blob';
    }
    this.isBlob = false;

    const request = await this.http.post(this.URL, data, requestParam).toPromise().then(
      res => {
        if(blob) {
          return this.openFile(res);
        } else {
          return res;
        }
      }
    ).catch(
      (e: any) => throwError(this.handleErrorObservable(e))
    );
    return request;
  }

  openFile(res) {
    let file = new Blob([res], { type: 'application/pdf' });            
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      console.log("res", res);
      return null;
  }

  public async put(data:any): Promise<any> {
    let requestParam:any;
    requestParam = {};
    requestParam.headers = this.headers;
    if (this.isBlob) {
      requestParam.responseType = 'blob';
    }
    this.isBlob = false;
    const request = await this.http.put(this.URL, data, requestParam).toPromise().then(
      res => {
        return res;
      }
    ).catch(
      (e: any) => throwError(this.handleErrorObservable(e))
    );
    return request;
  }

  public async patch(data:any): Promise<any> {
    let requestParam:any;
    requestParam = {};
    requestParam.headers = this.headers;
    if (this.isBlob) {
      requestParam.responseType = 'blob';
    }
    this.isBlob = false;
    const request = await this.http.patch(this.URL, data, requestParam).toPromise().then(
      res => {
        return res;
      }
    ).catch(
      (e: any) => throwError(this.handleErrorObservable(e))
    );
    return request;
  }

  public async delete(): Promise<any> {
    let requestParam:any;
    requestParam = {};
    requestParam.headers = this.headers;
    if (this.isBlob) {
      requestParam.responseType = 'blob';
    }
    this.isBlob = false;
    const request = await this.http.delete(this.URL, requestParam).toPromise().then(
      res => {
        return res;
      }
    ).catch(
      (e: any) => throwError(this.handleErrorObservable(e))
    );
    return request;
  }

  public async get(): Promise<any> {
    let requestParam:any;
    requestParam = {};
    requestParam.headers = this.headers;
    if (this.isBlob) {
      requestParam.responseType = 'blob';
    }
    this.isBlob = false;
    const request = await this.http.get(this.URL, requestParam).toPromise().then(
      res => {
        return res;
      }
    ).catch(
      (e: any) => throwError(this.handleErrorObservable(e))
    );
    return request;
  }

  async _apiRequest(url:string, data:any, callback:any = null) {
    const response: any = await this.makeRequest(url, data);
    const result = JSON.parse(JSON.stringify(response));
    if (result && !result.is_error) {
      if (callback) {
        return callback(result);
      }
      return result;
    } else {
      return result;
    }
  }

  // To call PUT request call
  async PUT_apiRequest(url:string, data:any, callback = null) {
    this.methodType = configuration.REQUEST.PUT;
    return await this._apiRequest(url, data, callback);    
  }

  // To call POST request call
  async POST_apiRequest(url:string, data:any, callback = null) {
    this.methodType = configuration.REQUEST.POST;
    return await this._apiRequest(url, data, callback);
  }

  // To call PATCH request call
  async PATCH_apiRequest(url:string, data:any, callback = null) {
    this.methodType = configuration.REQUEST.PATCH;
    return await this._apiRequest(url, data, callback);
  }

  // To call GET request call
  async GET_apiRequest(url:string, callback = null) {
    this.methodType = configuration.REQUEST.GET;
    return await this._apiRequest(url, null, callback);
  }

    // To call DELETE request call
  async DELETE_apiRequest(url:string, callback = null) {
    this.methodType = configuration.REQUEST.DELETE;
    return await this._apiRequest(url, null, callback);
  }

  getData(res:any) {
    if(res && !res.error && res.data) {
      return res.data
    } else {
      return null;
    }
  }
}
